// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2Dj-Y","footer":"ReportModalFilter_footer__33aSZ"};